import React, {useEffect, useState} from "react";
import {Button, Col, notification, Popconfirm, Row, Table} from "antd";
import Spinner from "../../../../spinner";
import {consignorService} from "../../../../../services";
import AddParamOnContractCreate from "../../../../modals/add-param-on-contract-create";
import i18n from "../../../../../i18n";

export default function AddParamsOnContract({ shipperCompanyID }) {
    const [loading, setLoading] = useState(true);
    const [needUpdate, setNeedUpdate] = useState(true);

    const [isShowAddParamModal, setIsShowAddParamModal] = useState(false);

    const [addParamsList, setAddParamsList] = useState([]);

    const paramTypes = {
        doc: "Документ",
        param: "Значение",
    };

    useEffect(() => {
        if (needUpdate && shipperCompanyID) {
            setLoading(true);

            consignorService
                .getShipperCompanyAddPramsOnContractList(shipperCompanyID)
                .then((response) => {
                    setAddParamsList(response);
                    setLoading(false);
                    setNeedUpdate(false);
                });
        }
    }, [needUpdate]);

    const handleDeleteParam = (paramName) => {
        setLoading(true);

        consignorService
            .removeShipperCompanyAddParam(shipperCompanyID, paramName)
            .then((result) => {
                notification.success({
                    message: i18n.t('components.notification.titles.removeShipperCompanyAddParam'),
                    description: result.message,
                });

                setNeedUpdate(true);
            })
            .catch((err) => {
                notification.error({
                    message: i18n.t('components.notification.titles.removeShipperCompanyAddParam'),
                    description: err,
                });

                setLoading(false)
            });
    }

    const columns = [
        {
            title: i18n.t('consignorPage.shipperCompanySettings.table.name.title'),
            dataIndex: 'Alias',
            key: 'alias',
            width: '35%',
            sorter: (a, b) => {
                return a.surname.localeCompare(b.surname);
            },
        },
        {
            title: i18n.t('consignorPage.shipperCompanySettings.table.type.title'),
            dataIndex: 'Type',
            key: 'type',
            width: '12%',
            render: (data) => {
                return paramTypes[data];
            },
            sorter: (a, b) => {
                return a.firstName.localeCompare(b.firstName);
            },
        },
        {
            title: '',
            key: 'questionnaire',
            render: (text, record) => {
                return (
                    <React.Fragment>
                        <Popconfirm
                          title={i18n.t('main.confirm.questions')}
                          okText={i18n.t('main.confirm.answer.yes')}
                          cancelText={i18n.t('main.confirm.answer.no')}
                            onConfirm={() => {handleDeleteParam(record.Name)}}
                        >
                            <Button
                                type="primary"
                                htmlType="button"
                                size="small"
                                className="small-button typical-btn-red"
                            >
                                {i18n.t('main.buttons.delete')}
                            </Button>
                        </Popconfirm>
                    </React.Fragment >
                );
            }
        },
    ];

    let bigButtonStyle = { width: '190px', height: '40px', background: '#1CAA53', position: 'static', borderRadius: '10px', float: 'right', borderColor: "#1CAA53" };

    return (
        <React.Fragment>
            <Row style={{ marginBottom: "25" }}>
                <Col className={"content-header"} style={{ marginBottom: "0px" }} span={12}>{i18n.t('consignorPage.shipperCompanySettings.contentHeader')}</Col>
                <Col span={8} style={{ marginBottom: "0px" }} offset={4}>
                    <Button type="primary"
                            htmlType="button"
                            style={bigButtonStyle}
                            onClick={() => {
                                setIsShowAddParamModal(true);
                            }}>

                      {i18n.t('consignorPage.shipperCompanySettings.buttons.add')}
                    </Button>
                    <AddParamOnContractCreate isShow={isShowAddParamModal} setIsShow={setIsShowAddParamModal} setNeedUpdate={setNeedUpdate} shipperCompanyID={shipperCompanyID} />
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
                        <Table
                            style={{ minWidth: "700px" }}
                            columns={columns}
                            dataSource={addParamsList}
                            locale={{ emptyText: i18n.t('main.empty') }}
                            rowKey="name"
                            size="small"
                            pagination={{
                                pageSize: 50,
                            }}
                        />
                    </Spinner>
                </Col>
            </Row>
        </React.Fragment>
    );
}
